import type { CVideoGalleryOuterTranslations } from "./pl";

export const de: CVideoGalleryOuterTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Videos entsprechen den Suchkriterien.",
  searchPlaceholder: "Suchen...",
  selectCity: "Stadt auswählen",
  backToList: "<- Zurück zur Videoliste",
  unsupportedVideo: "Video in neuem Fenster öffnen",
  paginationLabel: (page: number, totalPages: number) =>
    `Seite ${page} von ${totalPages}`,
  prevPage: "Zurück",
  nextPage: "Weiter",
};
